import React from "react";
import LegalPrivacyPage from "../Components/LegalPrivacy/LegalPrivacyPage";

const LegalPrivacy = () => {
  return <LegalPrivacyPage />;
};

export default LegalPrivacy;